/*
 * Expense Inventory list GraphQL specification
 * @module src/graphql/getExpenseInventoryList
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

/**  Expense Inventory list GraphQL API query */
export const GET_EXPENSE_INVENTORY_LIST = gql`
  query getExpenseInventoryList(
    $limit: Int
    $offset: Int
    $type: String
    $orderBy: String
    $orderSortType: String
    $filters: ExpenseInventoryFilters
  ) {
    getExpenseInventoryList(
      limit: $limit
      offset: $offset
      type: $type
      orderBy: $orderBy
      orderSortType: $orderSortType
      filters: $filters
    ) {
      id
      caseExternalId
      caseNumber
      status
      accountName
      accountDisplay
      salesRepName
      salesRepHoldReason
      submittedDate
      orderType
      failureReason
      erpOrderNumber
      writeOffType
    }
  }
`;
